import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldEvent'])
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldEvent'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldEvent'])
    },
}